import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/staffGrossSalesSaga";

const UpdateBtns = () => {
  const dispatch = useDispatch();
  const filtersDirty = useSelector((state) => state.staffGrossSales.filtersDirty);

  return filtersDirty ? (
    <>
      <button className="submit" onClick={() => dispatch(actionCreators.updateData())}>
        Update
      </button>

      <button className="submit reset" onClick={() => dispatch(actionCreators.resetData())}>
        Reset
      </button>
    </>
  ) : null;
};

export default UpdateBtns;
